module.exports = __webpack_public_path__ + "assets/img/18-l.9cdfe91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/18-l.jpg
// module id = qMvQ
// module chunks = 0